import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useViewport } from "@xyflow/react";
const LINE_COLOR = "rgba(100, 116, 139, 0.45)";
const GUIDE_Z_INDEX = 1000;
export function HelperLinesOverlay({ vertical, horizontal }) {
    const { x: tx, y: ty, zoom } = useViewport();
    if (vertical === undefined && horizontal === undefined) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            vertical !== undefined && /*#__PURE__*/ _jsx("div", {
                style: {
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: vertical * zoom + tx,
                    width: 0,
                    borderLeft: `1px dashed ${LINE_COLOR}`,
                    pointerEvents: "none",
                    zIndex: GUIDE_Z_INDEX
                }
            }),
            horizontal !== undefined && /*#__PURE__*/ _jsx("div", {
                style: {
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: horizontal * zoom + ty,
                    height: 0,
                    borderTop: `1px dashed ${LINE_COLOR}`,
                    pointerEvents: "none",
                    zIndex: GUIDE_Z_INDEX
                }
            })
        ]
    });
}

//# sourceMappingURL=HelperLinesOverlay.js.map